import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = 'auth_token';
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Endpointy, ktorých 401 NEMÁ vyvolať odhlásenie/redirect (login rieši chybu sám).
const AUTH_ENDPOINTS = ['/auth/login', '/sso/prevadzka-landing', '/sso/admin-landing'];

// Globálny 401 handler: expirovaný/neplatný token → zahoď a presmeruj na LoginPage.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    const isAuthEp = AUTH_ENDPOINTS.some((e) => url.includes(e));
    if (status === 401 && !isAuthEp) {
      const had = getToken();
      clearToken();
      // reload len ak sme boli „prihlásení" – zabráni slučke na LoginPage
      if (had && window.location.pathname !== '/login') {
        window.location.replace('/');
      }
    }
    return Promise.reject(error);
  }
);
